// src/components/common/Dropdown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const Dropdown = ({
  value,
  onValueChange,
  items = [],
  placeholder = 'Select...',
  error,
  disabled,
  renderItem,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (itemValue) => {
    onValueChange(itemValue);
    setIsOpen(false);
  };

  const selectedItem = items.find(item => item.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const defaultRenderItem = (item) => (
    <div className="p-3 hover:bg-gray-50 cursor-pointer">
      <span className="text-gray-900">{item.name || item.label}</span>
    </div>
  );

  const renderItemFn = renderItem || defaultRenderItem;

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`
          w-full flex items-center justify-between px-4 py-3 border rounded-lg
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
          ${error ? 'border-red-300' : 'border-gray-300'}
          ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : 'bg-white hover:bg-gray-50'}
          ${className}
        `}
      >
        <span className={`${selectedItem ? 'text-gray-900' : 'text-gray-500'}`}>
          {selectedItem ? (selectedItem.name || selectedItem.label) : placeholder}
        </span>
        <FiChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {error && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}

      {isOpen && !disabled && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {items.map((item) => (
            <div
              key={item.id || item.value}
              onClick={() => handleSelect(item.value)}
            >
              {renderItemFn(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;